import Vue from 'vue'
Vue.mixin({
  methods: {
    convertDate (inputDate) {
      var splitDate = inputDate.split('-')
      if (splitDate.count === 0) {
        return null
      }

      var year = splitDate[0]
      var month = splitDate[1]
      var day = splitDate[2]

      return month + '\\' + day + '\\' + year
    },
    invertDate (data) {
      var dia = data.split('/')[0]
      var mes = data.split('/')[1]
      var ano = data.split('/')[2]

      return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2)
    }
  }
})
